export default "__VITE_ASSET__CCYbI73E__"